import React, { useEffect } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import MakeRequest from "../Helpers/MakeRequest.js";
import { checkAuth } from "../Helpers/ProtectedRoute.js";

const adminLogin = async (username, password) => {
    try {
        const response = await MakeRequest({ username, password }, "auth/admin-login", "post");
        if(response.status < 400){
            return response.data
        };
        throw new Error("Login failed");
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
};

export default () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const data = await adminLogin(username, password);
            alert("Admin login successful");
            // Redirect to home after successful login
            window.location.href = '/home';
        } catch (err) {
            setError(err.message || "Login failed");
        }
    };

    useEffect(() => {
        const checkLoginStatus = async () => {
            const authStatus = await checkAuth();
            if (authStatus.isAuthenticated) {
                // Already authenticated, redirect to home
                window.location.href = '/home';
            };
        };
        checkLoginStatus();
    }, []);

    return (
        <Container style={{ maxWidth: 400, marginTop: 50 }}>
            <h2 className="mb-4">Admin Login</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>
                Logga in för att få tillgång till webbplatsen under underhåll.
            </p>
            <Form onSubmit={(e)=> handleSubmit(e)}>
                <Form.Group className="mb-3" controlId="formUsername">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </Form.Group>
                {error && <div style={{ color: "red", marginBottom: '15px' }}>{error}</div>}
                <Button variant="primary" type="submit">
                    Login
                </Button>
            </Form>
        </Container>
    );
};
